import React from 'react';
import styles from '../Navigation.less';

const getArrowNameBasedOnSidebarExpanded = (sidebarDesktopExpanded) => (sidebarDesktopExpanded ? 'left' : 'right');

const NavigationArrow = ({ sidebarDesktopExpanded, toggleSidebarDesktop }) => (
  <div className={`grid-item border-right ${styles.navigation_arrow} ${sidebarDesktopExpanded ? '' : styles.folded}`}>
    <span
      id="navigation-arrow"
      onClick={toggleSidebarDesktop}
      className={`font-xl grid grid-item font-lightgrey is24-icon-arrow-${getArrowNameBasedOnSidebarExpanded(sidebarDesktopExpanded)}`}
      role="button"
      onKeyDown={(event)=> {
        if (event.key === 'ArrowUp'){
          toggleSidebarDesktop()
        }
      }}
      tabIndex={0}
    />
  </div>
);

export default NavigationArrow;
